import Ilamsiz from "../Ilamsiz/Ilamsiz";
import MtsAlacakKalem, {MtsParaBirimi} from "./MtsAlacakKalem";
import Args from "@/plugins/uyap-plugin/takip_ac/parser/Args";

export default class MtsDiger extends Ilamsiz {
    id: any = null;
    no: string = "";
    tutarTL: any;
    selectedParaBirimi: MtsParaBirimi = new MtsParaBirimi();
    tarih: string = "";
    muacceliyetTarihi: string = "";
    aciklama: string = "";
    alacakKalemi: string = "";
    alacakKalemleri: MtsAlacakKalem[] = []

    static fromJson(jsonData: any): MtsDiger {
        return Args.staticFromJson(jsonData,new MtsDiger());
    }

    constructor() {
        super();
    }

    toUyapJson() {
        //this.alacakKalemi =
        this.alacakKalemleri.forEach(alacakKalemi=>{
            console.log("MTS TO UYAP JSON ALACAK KALEM faizBilgileri",alacakKalemi.faizBilgileri);
            if(Array.isArray(alacakKalemi.faizBilgileri)){
                alacakKalemi.faizBilgileri = {};
                console.log("MTS TO UYAP JSON ALACAK KALEM faizBilgileri [] TO {}");
            }
        })
        return this;
    }
}

